import { Module } from 'vuex';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';

export const state = {
    currentAnimation: 'ava_idle_notalk_01',
    animations: {},
    error: false,
};

const namespaced = true;

export const ava = {
    namespaced,
    state,
    getters,
    actions,
    mutations,
};